import { Nemesis } from '../../../../aer-types/types'

export const nemeses: Nemesis[] = [
  {
    expansion: 'ATD',
    name: 'The Infecter',
    id: 'TheInfecter',
    health: 60,
    difficulty: 4,
    expeditionRating: 1,
    additionalInfo: '',
  },
  {
    expansion: 'ATD',
    name: 'The Coven',
    id: 'TheCoven',
    health: '*',
    difficulty: 5,
    expeditionRating: 2,
    additionalInfo: '',
  },
  {
    expansion: 'ATD',
    name: 'The Blight',
    id: 'TheBlight',
    health: 60,
    difficulty: 7,
    expeditionRating: 3,
    additionalInfo: '',
  },
  {
    expansion: 'ATD',
    name: 'The Wrath',
    id: 'TheWrath',
    health: 6,
    difficulty: 8,
    expeditionRating: 4,
    additionalInfo: '',
    fightFiveAdditionalInfo: `
    <p>Play using Increased Difficulty.</p>
    <p>SETUP: Two different players each suffer 3 damage.</p>
    `,
  },
]
